module.exports = __webpack_public_path__ + "static/media/business_deal.1a7de430.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/img/business_deal.svg
// module id = 1087
// module chunks = 2